import React from 'react';
import { Section } from '@fiverr-private/layout_components';
import { getContext } from '@fiverr-private/fiverr_context';
import { ROLLOUTS } from '../../../lib/constants/experiments';
import { CATEGORIES_ID_MAPPER, PJM_BANNER_SUPPORTED_CATEGORY_IDS } from '../../../lib/constants/verticalsData';
import { PjmBanner } from '../PjmBanner/PjmBanner';

interface BannerSectionProps {
    verticalId: number;
    verticalTitle: string;
    rollouts: { [key: string]: boolean };
}

const buildActiveBannerComponent = ({ verticalId, verticalTitle, rollouts }) => {
    const { experience } = getContext();
    let showProjectPartnerBanner = false;

    if (rollouts[ROLLOUTS.PROJECT_PARTNER_BANNER_ROLLOUT] && PJM_BANNER_SUPPORTED_CATEGORY_IDS.includes(verticalId)) {
        if (experience?.isBusiness) {
            showProjectPartnerBanner = true;
        } else if (verticalId !== CATEGORIES_ID_MAPPER['writing-translation']) {
            showProjectPartnerBanner = rollouts[ROLLOUTS.PROJECT_PARTNER_BANNER_IN_MARKETPLACE_ROLLOUT];
        }
    }

    if (showProjectPartnerBanner) {
        return <PjmBanner verticalId={verticalId} verticalTitle={verticalTitle} />;
    }
};

export const BannerSection: React.FC<BannerSectionProps> = ({ verticalTitle, verticalId, rollouts }) => {
    const component = buildActiveBannerComponent({
        verticalId,
        verticalTitle,
        rollouts,
    });

    if (!component) {
        return null;
    }

    return (
        <Section paddingBottom="0" paddingTop="14">
            {component}
        </Section>
    );
};
